import { PropsWithChildren, ReactNode, useMemo } from 'react';
import { useCheckoutContext } from '../CheckoutContext';
import { CheckoutBreadcrumbs } from '../Breadcrumbs';
import { CheckoutState } from '@shared/types';
import { useIam } from '../../../services/IAm/hooks';
import { LoginStep } from '../LoginStep';
import { EmbedBackToSiteBanner } from '../EmbedBackToSiteBanner';

export type CheckoutFlowWrapperProps<TCheckoutState extends CheckoutState> = PropsWithChildren<{
    unauthenticatedSteps: Array<{ key: TCheckoutState['currentStep']; label: string }>;
    authenticatedSteps: Array<{ key: TCheckoutState['currentStep']; label: string }>;
}>;

export const CheckoutFlowWrapper = <TCheckoutState extends CheckoutState>(
    props: CheckoutFlowWrapperProps<TCheckoutState>
): ReactNode => {
    const { unauthenticatedSteps, authenticatedSteps, children } = props;
    const { iam } = useIam();
    const { checkoutState, course, educator, submitResponse } = useCheckoutContext();
    const isOnAuthenticatedStep = useMemo(() => {
        return authenticatedSteps.some((authenticatedStep) => {
            return authenticatedStep.key === checkoutState.currentStep;
        });
    }, [authenticatedSteps, checkoutState.currentStep]);
    return (
        <div>
            <EmbedBackToSiteBanner />
            <CheckoutBreadcrumbs
                unauthenticatedSteps={unauthenticatedSteps}
                authenticatedSteps={authenticatedSteps}
                currentStep={checkoutState.currentStep}
                submitResponse={submitResponse}
                origin={checkoutState.origin}
                educatorSlug={educator.slug}
                courseSlug={course.slug}
            />
            {iam.authenticated === false && isOnAuthenticatedStep ? <LoginStep /> : children}
        </div>
    );
};
